import { useState } from "react";

import { Button, addToast } from "@icg360/design-system";

import { trackEvent } from "utils";

import EditDocumentsEmailModal from "./edit-documents-email-modal";

type EditDocumentsEmailProps = {
  policyId: string;
};
const EditDocumentsEmail = ({ policyId }: EditDocumentsEmailProps) => {
  const [showEditModal, setShowEditModal] = useState(false);

  const openModal = () => {
    setShowEditModal(true);
    trackEvent("Update email address modal displayed", {
      paperlessType: "documents",
    });
  };

  return (
    <>
      <Button
        appearance="tertiary"
        size="xs"
        onPress={openModal}
        data-testid="documents-email-edit-btn"
      >
        Edit
      </Button>
      <EditDocumentsEmailModal
        show={showEditModal}
        handleClose={() => setShowEditModal(false)}
        policyId={policyId}
        onEditDocumentsSuccess={() => {
          setShowEditModal(false);
          addToast("Email address was updated successfully.", { icon: true });
        }}
      />
    </>
  );
};

export default EditDocumentsEmail;
